export default __webpack_public_path__ + "static/media/logo-loader-1.117262cf.svg";